<i class="fad fa-circle-info btn-xs btn-bordered text-{{type}} btn-icon simple-icon"
    [popover]="warning"
    container="body"
    containerClass="confirmation-popover"
    placement="{{placement}}"
    triggers="mouseenter mouseleave"
    containerClass="many-to-one-popover {{type}}-notice"
    #pop="bs-popover"></i>
<ng-template #warning>
    {{text | translate}}
</ng-template>